import { createGraphQLClientWithMiddleware } from "services/graphqlClient";
import { useBillingNoteByDeliveryItemReportColumnDefs } from "./columnDefs";
import { IServerSideGetRowsParams, GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import AgGrid from "components/UI/AgGrid";
import { GraphQLClient } from "graphql-request";
import { RefObject } from "react";
import { BILLING_NOTE_BY_DELIVERY_ITEM_REPORT } from "services/Sales/Report/BillingNoteReportViewsAggrid";
import CustomizedBoxTable from "components/Custom/CustomizedBoxTable";
import { dateFilterModel } from "utils/AgGridFilter";

interface Props {
  gridRef: RefObject<AgGridReact>;
  height?: string | number;
}

const BillingNoteByDeliveryItemReportTable = ({ gridRef, height }: Props) => {
  const graphQLClientWms: GraphQLClient =
    createGraphQLClientWithMiddleware("sales");
  const columnDefs = useBillingNoteByDeliveryItemReportColumnDefs();
  const datasource = {
    async getRows(params: IServerSideGetRowsParams) {
      const { request } = params;
      const { startRow, endRow, filterModel, sortModel } = request;
      const { issue_date, due_date, created_date, dt_issue_date } = filterModel;
      const formatFilter = {
        ...filterModel,
        issue_date: dateFilterModel(issue_date),
        due_date: dateFilterModel(due_date),
        created_date: dateFilterModel(created_date),
        dt_issue_date: dateFilterModel(dt_issue_date),
      };
      const formatSort = [...sortModel];
      try {
        const { BillingNoteByDeliveryItemReportViewsAggrid } =
          await graphQLClientWms.request(BILLING_NOTE_BY_DELIVERY_ITEM_REPORT, {
            aggridInput: {
              startRow,
              endRow,
              filterModel: formatFilter,
              sortModel: formatSort,
            },
          });
        params.success({
          rowData: BillingNoteByDeliveryItemReportViewsAggrid.results,
          rowCount: BillingNoteByDeliveryItemReportViewsAggrid.count,
        });
      } catch (err) {
        params.fail();
      }
    },
  };

  const onGridReady = (params: GridReadyEvent) => {
    params.api.onFilterChanged();
    params.api.setServerSideDatasource(datasource);
  };

  return (
    <CustomizedBoxTable height={height}>
      <AgGrid ref={gridRef} columnDefs={columnDefs} onGridReady={onGridReady} />
    </CustomizedBoxTable>
  );
};

export default BillingNoteByDeliveryItemReportTable;
